import { z } from "zod";
export const PRIVACY_TEXT_KINDS = ["PRIVACY_NOTICE", "EXPLICIT_CONSENT", "COMMERCIAL_MESSAGE"];
export const privacyTextKindSchema = z.enum(PRIVACY_TEXT_KINDS);
export const PRIVACY_TEXT_KIND_LABELS = {
    PRIVACY_NOTICE: "Aydınlatma metni",
    EXPLICIT_CONSENT: "Açık rıza metni",
    COMMERCIAL_MESSAGE: "Ticari elektronik ileti onayı",
};
/** Açık rıza amaç kodları (öneri listesi; kiracı yeni kod da açabilir — `^[A-Z][A-Z0-9_]{1,39}$`). */
export const PRIVACY_CONSENT_PURPOSES = [
    "LOYALTY_PROFILING",
    "DRIVER_APP_LINK",
    "LOCATION",
    "DATA_SHARING",
];
export const PRIVACY_CONSENT_PURPOSE_LABELS = {
    LOYALTY_PROFILING: "Sadakat programı ve kişiselleştirilmiş kampanya",
    DRIVER_APP_LINK: "Müşteri uygulaması hesabıyla bağlantı",
    LOCATION: "Konum verisinin işlenmesi",
    DATA_SHARING: "Üçüncü kişilerle paylaşım",
};
export const PRIVACY_TEXT_STATUSES = ["DRAFT", "PUBLISHED", "RETIRED"];
export const privacyTextStatusSchema = z.enum(PRIVACY_TEXT_STATUSES);
export const PRIVACY_TEXT_STATUS_LABELS = {
    DRAFT: "Taslak",
    PUBLISHED: "Yayımda",
    RETIRED: "Yürürlükten kalktı",
};
export const CONSENT_DECISIONS = ["ACKNOWLEDGED", "GRANTED", "DENIED", "WITHDRAWN"];
export const consentDecisionSchema = z.enum(CONSENT_DECISIONS);
export const CONSENT_DECISION_LABELS = {
    ACKNOWLEDGED: "Okundu (aydınlatma)",
    GRANTED: "Verildi",
    DENIED: "Reddedildi",
    WITHDRAWN: "Geri alındı",
};
export const CONSENT_CHANNELS = ["STATION", "POS", "WEB", "DRIVER_APP", "CALL_CENTER", "PAPER"];
export const consentChannelSchema = z.enum(CONSENT_CHANNELS);
export const CONSENT_CHANNEL_LABELS = {
    STATION: "İstasyon",
    POS: "Kasa",
    WEB: "Web",
    DRIVER_APP: "Müşteri uygulaması",
    CALL_CENTER: "Çağrı merkezi",
    PAPER: "Islak imzalı form",
};
/** İleti izninin geldiği kanal: rıza kanalları + İYS'den gelen kayıt (`IYS`, izin metnine bağlı olmayabilir). */
export const MESSAGE_PERMISSION_SOURCE_CHANNELS = [...CONSENT_CHANNELS, "IYS"];
export const messagePermissionSourceChannelSchema = z.enum(MESSAGE_PERMISSION_SOURCE_CHANNELS);
export const MESSAGE_PERMISSION_SOURCE_CHANNEL_LABELS = {
    ...CONSENT_CHANNEL_LABELS,
    IYS: "İleti Yönetim Sistemi (İYS)",
};
export const MESSAGE_CHANNELS = ["SMS", "EMAIL", "CALL"];
export const messageChannelSchema = z.enum(MESSAGE_CHANNELS);
export const MESSAGE_CHANNEL_LABELS = {
    SMS: "SMS",
    EMAIL: "E-posta",
    CALL: "Arama",
};
export const IYS_STATUSES = ["PENDING", "SYNCED", "FAILED", "NOT_REQUIRED"];
export const iysStatusSchema = z.enum(IYS_STATUSES);
export const IYS_STATUS_LABELS = {
    PENDING: "İYS'ye gönderilecek",
    SYNCED: "İYS'de",
    FAILED: "İYS hatası",
    NOT_REQUIRED: "İYS gerekmez",
};
export const MARKETING_MESSAGE_STATUSES = [
    "SENT",
    "SKIPPED_NO_PERMISSION",
    "SKIPPED_NO_CONTACT",
    "SKIPPED_ANONYMIZED",
    "FAILED",
];
export const marketingMessageStatusSchema = z.enum(MARKETING_MESSAGE_STATUSES);
export const MARKETING_MESSAGE_STATUS_LABELS = {
    SENT: "Gönderildi",
    SKIPPED_NO_PERMISSION: "Gönderilmedi — izin yok",
    SKIPPED_NO_CONTACT: "Gönderilmedi — iletişim bilgisi yok",
    SKIPPED_ANONYMIZED: "Gönderilmedi — anonimleştirilmiş",
    FAILED: "Gönderim hatası",
};
export const DATA_SUBJECT_REQUEST_TYPES = [
    "ACCESS",
    "RECTIFICATION",
    "ERASURE",
    "OBJECTION",
    "OTHER",
];
export const dataSubjectRequestTypeSchema = z.enum(DATA_SUBJECT_REQUEST_TYPES);
export const DATA_SUBJECT_REQUEST_TYPE_LABELS = {
    ACCESS: "Bilgi talebi / veri dökümü",
    RECTIFICATION: "Düzeltme",
    ERASURE: "Silme / anonimleştirme",
    OBJECTION: "İtiraz",
    OTHER: "Diğer",
};
export const DATA_SUBJECT_REQUEST_CHANNELS = [
    "WEB",
    "EMAIL",
    "KEP",
    "PAPER",
    "DRIVER_APP",
    "CALL_CENTER",
];
export const dataSubjectRequestChannelSchema = z.enum(DATA_SUBJECT_REQUEST_CHANNELS);
export const DATA_SUBJECT_REQUEST_CHANNEL_LABELS = {
    WEB: "Web formu",
    EMAIL: "E-posta",
    KEP: "KEP",
    PAPER: "Yazılı / elden",
    DRIVER_APP: "Müşteri uygulaması",
    CALL_CENTER: "Çağrı merkezi",
};
export const DATA_SUBJECT_REQUEST_STATUSES = ["RECEIVED", "IN_PROGRESS", "COMPLETED", "REJECTED"];
export const dataSubjectRequestStatusSchema = z.enum(DATA_SUBJECT_REQUEST_STATUSES);
export const DATA_SUBJECT_REQUEST_STATUS_LABELS = {
    RECEIVED: "Alındı",
    IN_PROGRESS: "İşlemde",
    COMPLETED: "Tamamlandı",
    REJECTED: "Reddedildi",
};
//# sourceMappingURL=enums.js.map